// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetTaxExemptionCertificatesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import { createContext } from "react";

export function getTECertificateState(state: ApplicationState, certificateId: string | undefined) {
    return getById(
        state.greif.data.taxExemptionCertificates,
        certificateId,
        id => state.greif.data.taxExemptionCertificates.idByCertificate[id],
    );
}

export function getTaxExemptionCertificatesDataView(
    state: ApplicationState,
    getTaxExemptionCertificatesParameter?: GetTaxExemptionCertificatesApiParameter,
) {
    return getDataView(state.greif.data.taxExemptionCertificates, getTaxExemptionCertificatesParameter);
}

export const TaxExemptionCertificatesDataViewContext = createContext<
    ReturnType<typeof getTaxExemptionCertificatesDataView>
>({
    value: undefined,
    isLoading: false,
});

export const TECertificateStateContext = createContext<ReturnType<typeof getTECertificateState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
